module.exports = __webpack_public_path__ + "media/images/link-34b0d7bb0b481c771a908ed6f3c45147.png";